import { render, staticRenderFns } from "./sponsoredBusiness.vue?vue&type=template&id=6236933f&scoped=true"
import script from "./sponsoredBusiness.vue?vue&type=script&lang=js"
export * from "./sponsoredBusiness.vue?vue&type=script&lang=js"
import style0 from "./sponsoredBusiness.vue?vue&type=style&index=0&id=6236933f&prod&scoped=true&lang=css"
import style1 from "./sponsoredBusiness.vue?vue&type=style&index=1&id=6236933f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6236933f",
  null
  
)

export default component.exports